import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        messages: '=',
        courseVersion: '=',
        form: '='
    },
    template: `
        <div class="loader02" ng-if="vm.saving">
            <p>{{ 'general.Please wait. Actions with large amount of data take more time than usual' | translate }}</p>
        </div>
        <div class="wrapper">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
                    <h2>{{ 'course.Archive version' | translate }}</h2>
                </div>
                <div class="modal-body">
                    <div class="alert alert-plain" ng-repeat="message in vm.messages">
                        <p>{{ message }}</p>
                    </div>
                    <form ng-submit="vm.save()" ng-if="vm.showAdditionalOptions">
                        <form-wrapper form="vm.form">
                            <h3>{{ 'version.In addition to archiving the version you can additionally perform following actions' | translate }}</h3>
                            <ul class="checkboxes">
                                <li ng-if="vm.showCancelOccurrences">
                                    <form-row error="vm.form.errors.cancelUnfinishedOccurrences">
                                        <label>
                                            <input
                                                type="checkbox"
                                                ng-model="vm.form.model.cancelUnfinishedOccurrences"
                                            >
                                            {{ 'version.Cancel unfinished connected occurrences' | translate }}
                                        </label>
                                        <form-row-error></form-row-error>
                                    </form-row>
                                </li>
                                <li ng-if="vm.showStopAllAPGs">
                                    <form-row error="vm.form.errors.stopAllAPGs">
                                        <label>
                                            <input
                                                type="checkbox"
                                                ng-disabled="vm.form.model.cancelAllAPGs"
                                                ng-model="vm.form.model.stopAllAPGs"
                                            > {{ 'version.Stop all connected automated planning groups' | translate }}<br>
                                            <small>{{ 'version.stop_apg_groups_info_message' | translate }}</small>
                                        </label>
                                        <form-row-error></form-row-error>
                                    </form-row>
                                </li>
                                <li ng-if="vm.showCancelAllAPGs">
                                    <form-row error="vm.form.errors.cancelAllAPGs">
                                        <label>
                                            <input
                                                type="checkbox"
                                                ng-disabled="vm.form.model.stopAllAPGs"
                                                ng-model="vm.form.model.cancelAllAPGs"
                                            > {{ 'version.Cancel all connected automated planning groups' | translate }}<br>
                                            <small>{{ 'version.cancel_apg_groups_info_message' | translate }}</small>
                                        </label>
                                        <form-row-error></form-row-error>
                                    </form-row>
                                </li>
                            </ul>
                        </form-wrapper>
                    </form>
                </div>
                <div class="modal-footer">
                    <ul class="actions01">
                        <li class="primary">
                            <button class="btn main" type="button" ng-click="vm.archive()">{{ 'general.Archive' | translate }}</button>
                        </li>
                        <li>
                            <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()"
                            >{{ 'general.Cancel' | translate }}</button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($translate, $scope, lodash, CourseVersionService, toastr,
                 OCCURRENCE_STATUS_ENUM, AUTOMATED_PLANNING_GROUP_STATUS_ENUM) {
        this.$translate = $translate;
        this.$scope = $scope;
        this.lodash = lodash;
        this.CourseVersionService = CourseVersionService;
        this.toastr = toastr;
        this.OCCURRENCE_STATUS_ENUM = OCCURRENCE_STATUS_ENUM;
        this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM = AUTOMATED_PLANNING_GROUP_STATUS_ENUM;
    }

    $onInit () {
        this.showAdditionalOptions = this.showAdditionalOptions();
        this.saving = false;
    }

    showAdditionalOptions () {
        const hasOccurrences = this.courseVersion.courseOccurrences.length;

        this.showCancelOccurrences = hasOccurrences && this.lodash.filter(
            this.courseVersion.courseOccurrences,
            (occurrence) => (
                (
                    occurrence.status === this.OCCURRENCE_STATUS_ENUM.KEYS.PUBLISHED ||
                    occurrence.status === this.OCCURRENCE_STATUS_ENUM.KEYS.UNPUBLISHED
                ) &&
                occurrence.isFinished !== true &&
                !occurrence.automatedPlanningGroupId
            )
        ).length;

        const hasPlanningGroups = this.courseVersion.automatedPlanningGroups.length;

        this.showStopAllAPGs = hasPlanningGroups && this.lodash.filter(
            this.courseVersion.automatedPlanningGroups,
            (planningGroup) => (
                planningGroup.status !== this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.CANCELLED &&
                planningGroup.status !== this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.STOPPED
            )
        ).length;

        this.showCancelAllAPGs = hasPlanningGroups && this.lodash.filter(
            this.courseVersion.automatedPlanningGroups,
            (planningGroup) => (
                planningGroup.status !== this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.CANCELLED
            )
        ).length;

        return this.showCancelOccurrences || this.showStopAllAPGs || this.showCancelAllAPGs;
    }

    archive () {
        this.saving = true;
        this.form.model.isArchived = true;
        this.CourseVersionService.mapTrainingForms(this.form.model.courseTrainings);
        this.form.save().then((updatedVersion) => {
            this.saving = false;
            this.courseVersion = updatedVersion;
            this.CourseVersionService.nestCompositeModels(updatedVersion);
            this.form.model = updatedVersion;
            this.$scope.$emit('version:reload', updatedVersion);
            this.uibModalInstance.close();
        }).catch((response) => {
            this.toastr.error(response.data[0].message);
            this.saving = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/version/archive/index.js